import { render, staticRenderFns } from "./UploadImageCustomize.vue?vue&type=template&id=360a0cf0&scoped=true&"
import script from "./UploadImageCustomize.vue?vue&type=script&lang=js&"
export * from "./UploadImageCustomize.vue?vue&type=script&lang=js&"
import style0 from "./UploadImageCustomize.vue?vue&type=style&index=0&id=360a0cf0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "360a0cf0",
  null
  
)

export default component.exports